export const isTrackerAvailable = () =>
  typeof window !== 'undefined' && Boolean(window.gptr);

export const sendEventClick = (section, position) => {
  if (isTrackerAvailable()) {
    window.gptr('send', 'eventclick', { section, position });
  }
};

export const sendAddFavorites = (offerId) => {
  if (isTrackerAvailable()) {
    window.gptr('send', 'addfavorites', { offerId });
  }
};

export const sendRemoveFavorites = (offerId) => {
  if (isTrackerAvailable()) {
    window.gptr('send', 'removefavorites', { offerId });
  }
};
